import { createContext } from 'react';

const ListModuleContext = createContext<ListModuleContextProps>({});

export { ListModuleContext };
